export default "__VITE_ASSET__BJbCFwHQ__"